const FONT = {
  PRIMARY: '"Gilroy", Arial, sans-serif'
}

export default FONT
